"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomConfig = exports.isIdassPrivateDeployment = exports.isPrivateDeployment = void 0;
const constant_1 = require("../config/constant");
const process = __importStar(require("process"));
function isPrivateDeployment() {
    return Boolean(process.env.REACT_APP_DEPLOYMENT_MODELS === 'PRIVATE');
}
exports.isPrivateDeployment = isPrivateDeployment;
function isIdassPrivateDeployment() {
    return getCustomConfig().isIdaas && isPrivateDeployment();
}
exports.isIdassPrivateDeployment = isIdassPrivateDeployment;
function getCustomConfig() {
    return typeof window === 'object' && window.__initialization_data__.envVars || {
        LOGIN_DEFAULT_VERIFY_TYPE: constant_1.IDENTIFY_CODE_LOGIN,
        VIEW_NAME_MAX_COUNT: process.env.VIEW_NAME_MAX_COUNT || 30
    };
}
exports.getCustomConfig = getCustomConfig;
//# sourceMappingURL=env.js.map